import { Stack } from '@mui/material'
import BarchartInfoLogo from 'assets/BarchartInfoLogo'

import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'

const SameTagWarningCard = props => {
	const { title, description } = props
	return (
		<CardStandart
			sx={{
				padding: '16px',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
				gap: '8px',
			}}
		>
			<span>
				<BarchartInfoLogo
					style={{ color: COLORS.health, width: '20px', height: '20px' }}
				/>
			</span>
			<Stack direction={'column'} gap={'4px'}>
				<TypographyPrimary14Bold>{title}</TypographyPrimary14Bold>
				{description && (
					<TypographyPrimary12>{description}</TypographyPrimary12>
				)}
			</Stack>
		</CardStandart>
	)
}

export default SameTagWarningCard
